import { BiometricAuth } from '@aparajita/capacitor-biometric-auth';

/** Сколько приложение может пробыть в фоне без повторного Face ID (спека iOS, §4). */
export const LOCK_AFTER_MS = 5 * 60_000;

export function needsUnlock(hiddenAt: number | null, now: number): boolean {
  return hiddenAt !== null && now - hiddenAt >= LOCK_AFTER_MS;
}

/** Face ID, при его отсутствии — код-пароль телефона. Отказ и ошибка — false. */
export async function verifyFace(): Promise<boolean> {
  try {
    await BiometricAuth.authenticate({
      reason: 'Вход в CODE ERP',
      cancelTitle: 'Отмена',
      allowDeviceCredential: true,
    });
    return true;
  } catch {
    return false;
  }
}
